import axios from "axios"
import { handleResponse } from "."
import { BASE_URL } from "../utils/constant"

interface TxConfig {
  slippage?: number
  units?: number
  microLamports?: number
}

// Define request bodies for the endpoints
interface SwapToRequest {
  inputAmount: string
  outputMint: string
  config?: TxConfig // Adjust type based on TxConfig
}

interface SwapFromRequest {
  inputAmount: string
  inputMint: string
  config?: TxConfig // Adjust type based on TxConfig
}

interface SwapFromPercentRequest {
  p: number
  inputMint: string
  config?: TxConfig // Adjust based on TxConfig
}

const SERVICE_URL = `${BASE_URL}/trade` // Replace with your actual API base URL

export class TradeService {
  // Method to get the active account's address
  public static getActiveAccount = async (): Promise<string> => {
    return handleResponse<string>(axios.get(`${SERVICE_URL}/activeAccount`))
  }

  // Method to prepare the account using the provided identifier
  public static prepareAccount = async (identifier: string): Promise<string> => {
    return handleResponse<string>(axios.post(`${SERVICE_URL}/prepare`, { identifier }))
  }

  // Method to swap to a target mint with the specified input amount
  public static swapToTarget = async (request: SwapToRequest): Promise<string[]> => {
    return handleResponse<string[]>(axios.post(`${SERVICE_URL}/swap/to`, request))
  }

  // Method to swap from a target mint with the specified input amount
  public static swapFromTarget = async (request: SwapFromRequest): Promise<string[]> => {
    return handleResponse<string[]>(axios.post(`${SERVICE_URL}/swap/from`, request))
  }

  // Method to swap from a target mint with the specified input percent
  public static swapFromTargetByPercent = async (request: SwapFromPercentRequest): Promise<string[]> => {
    return handleResponse<string[]>(axios.post(`${SERVICE_URL}/swap/from/p`, request))
  }
}
